

export class GradoEducativo {

   GradoEducativoID:number;
    Nombre: string;
  }
  
